import React from "react";
import "../Styles/ReasonItem.css";
import doctorImage from "../Images/Why_Choose.jpeg";
import shieldIcon from "../Images/Sheild.png";
import AppointmentBtn from "./AppointmentBtn";

const ReasonItem = ({ showAppointmentBtn = false }) => {
  return (
    <div className="reason-item">
      <div className="reason-image-container">
        <img src={doctorImage} alt="Doctor" className="reason-image" />
      </div>
      <div className="reason-content">
        <h2 className="reason-heading">
          Why Choose{" "}
          <span className="highlight-image-underline">Dhotrad's </span> For All
          Your Dental Treatments?
        </h2>
        <p className="reason-description">
          We use only the best quality materials on the market in order to
          provide the best products to our patients.
        </p>
        <ul className="reason-points">
          <li>
            <img src={shieldIcon} alt="icon" /> Top quality dental team
          </li>
          <li>
            <img src={shieldIcon} alt="icon" /> State of the art dental services
          </li>
          <li>
            <img src={shieldIcon} alt="icon" /> Discount on all dental treatment
          </li>
          <li>
            <img src={shieldIcon} alt="icon" /> Enrollment is quick and easy
          </li>
        </ul>
        {showAppointmentBtn && <AppointmentBtn />}
      </div>
    </div>
  );
};

export default ReasonItem;
